import produce from 'immer';
import { useEffect, useState } from 'react';
import { Button, Dimmer, Loader } from 'semantic-ui-react';
import useClientCredentials from '../../../hooks/useClientCredentials';
import useClients from '../../../hooks/useClients';
import EntityData from '../../Common/EntityData';

const CredentialsDetails = ({ clientId, credentialType, onEdit }) => {
  const { credentials, isLoading } = useClientCredentials(clientId);
  const { clients } = useClients();
  const client = clients[clientId];
  const [credential, setCredential] = useState(undefined);
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (credentials) setCredential(credentials[credentialType]);
  }, [credentials, credentialType]);

  const getCredentials = () => {
    if (!client || !credential) return null;
    if (credentialType === 'sftp') {
      return produce(credential, (a) => {
        a.PrivateKey = '**********';
        a.PublicKey = '**********';
      });
    } else {
      return produce(credential, (a) => {
        if (!showPassword) a.Password = '*******';
      });
    }
  };

  const downloadFile = () => {
    function download(filename, text) {
      var element = document.createElement('a');
      element.setAttribute(
        'href',
        'data:text/plain;charset=utf-8,' + encodeURIComponent(text)
      );
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }

    var text = credential.PrivateKey;
    var filename = `${credential.SFTPUser}.pem`;

    download(filename, text);
  };

  return (
    <div>
      {isLoading || !credentials || !client ? (
        <Dimmer active>
          <Loader />
        </Dimmer>
      ) : credentials ? (
        <>
          <EntityData entity={getCredentials()} />
          {credentialType === 'sftp' ? (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button onClick={downloadFile}>Download pem file</Button>
            </div>
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <Button size={'tiny'} onClick={() => setShowPassword(true)}>
                View Password
              </Button>
              <Button size={'tiny'} onClick={onEdit}>
                Edit
              </Button>
            </div>
          )}
        </>
      ) : (
        'No Credentials'
      )}
    </div>
  );
};
export default CredentialsDetails;
